export const WEIGHTS = {
  BUSINESS_TYPE: 150,
  SUBTYPE: 120,
  INDUSTRY: 100,
  GOALS: 80,
  FEATURES: 80,
  STAGE: 60,
  BUDGET: 50,
  TECHNICAL_MATCH: 50,
  ESSENTIAL_CATEGORY: 80
} as const;

export const MAX_RECOMMENDATIONS = 4;
export const MIN_SCORE_THRESHOLD = 10;

export const DEFAULT_RECOMMENDATIONS: Record<string, string[]> = {
  solopreneur: ['Project Management', 'Accounting', 'Marketing', 'Time Tracking'],
  startup: ['Project Management', 'Analytics', 'Customer Support', 'Development'],
  'small-business': ['Accounting', 'Project Management', 'Invoicing', 'Marketing'],
  freelancer: ['Time Tracking', 'Project Management', 'Invoicing', 'Accounting'],
  trades: ['Field Service', 'Scheduling', 'Payment Processing', 'Invoicing'],
  'side-hustler': ['Marketing', 'E-commerce', 'Payment Processing', 'Social Media'],
  'agency': ['Project Management', 'Time Tracking', 'Invoicing', 'Collaboration'],
  'content-creator': ['Social Media', 'Marketing', 'Design & Creative', 'Project Management']
};